import { useEffect, useState, useCallback } from "react";

const KEY = "twentyproof_bookmarks";
const EVENT = "bookmarks-updated";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function write(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVENT));
}

export default function useBookmarks() {
  const [items, setItems] = useState(read());

  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const isSaved = useCallback(
    (type, id) => items.some((b) => b.type === type && b.id === id),
    [items]
  );

  const toggle = useCallback((type, id) => {
    const current = read();
    const exists = current.some((b) => b.type === type && b.id === id);
    const next = exists
      ? current.filter((b) => !(b.type === type && b.id === id))
      : [{ type, id, savedAt: Date.now() }, ...current];
    write(next);
    return !exists; // returns true if now saved
  }, []);

  const remove = useCallback((type, id) => {
    write(read().filter((b) => !(b.type === type && b.id === id)));
  }, []);

  return { items, isSaved, toggle, remove, count: items.length };
}
